export default {
    en: {
        amortissementRestant: ' of remaining amortization',
        and: ' and',
        chartTitle_1: 'Payment breakdown during the ',
        chartTitle_2: ' term',
        tooltipTitle:
            'These results are estimates based on current data, including the term selected. They depend on a number of factors.',
        tooltipAmortissementRestant:
            'Time left to fully repay your mortgage based on new terms.',
        tooltipHorsEcran: 'remaining amortization',
        seriesTitle: 'Payment breakdown',
        seriesCapital: 'Capital',
        seriesInteret: 'Interest',
        seriesAssurance: 'Insurance'
    },
    fr: {
        amortissementRestant: ' d’amortissement restant',
        and: ' et',
        chartTitle_1: 'Répartition des paiements durant le terme de ',
        chartTitle_2: '',
        tooltipTitle:
            'Ces résultats sont des estimations basées sur les données actuelles y compris le terme choisi. Ils pourraient varier en fonction de différents facteurs.',
        tooltipAmortissementRestant:
            'Temps requis pour rembourser la totalité de votre prêt hypothécaire en se basant sur les nouvelles modalités.',
        tooltipHorsEcran: 'amortissement restant',
        seriesTitle: 'Répartitions des paiements',
        seriesCapital: 'Capital',
        seriesInteret: 'Intérêt',
        seriesAssurance: 'Assurance'
    }
};
